import { useState } from "react";
import {
  createFavoriteItem,
  deleteFavoriteItem,
} from "Explore/Services/Favorite";

const useFavoriteItem = ({ itemId, itemType }) => {
  const [open, setOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: null, // "success" or "error"
    action: null, // "add" or "delete"
  });

  const getMessage = () => {
    if (alertData.action === "add") {
      return alertData.type === "success"
        ? "Added to favorite!"
        : "Something went wrong when adding! Please try again later";
    } else if (alertData.action === "delete") {
      return alertData.type === "success"
        ? "Removed from favorite!"
        : "Something went wrong when removing! Please try again later";
    } else {
      return alertData.type === "success"
        ? "Success"
        : "Something went wrong! Please try again later";
    }
  };

  const handleCreate = async () => {
    try {
      await createFavoriteItem({ itemId, itemType });
      setAlertData({ type: "success", action: "add" });
      setOpen(true);
      return true;
    } catch (error) {
      setAlertData({ type: "error", action: "add" });
      setOpen(true);
      return false;
    }
  };

  const handleDelete = async () => {
    try {
      await deleteFavoriteItem({ itemId });
      setAlertData({ type: "success", action: "delete" });
      setOpen(true);
      return true;
    } catch (error) {
      setAlertData({ type: "error", action: "delete" });
      setOpen(true);
      return false;
    }
  };

  return {
    createFavoriteItem: handleCreate,
    deleteFavoriteItem: handleDelete,
    snackbarProps: {
      open,
      onClose: () => setOpen(false),
      severity: alertData.type,
      message: getMessage(),
    },
  };
};

export default useFavoriteItem;
